import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_TEST_SCHOOLS = gql`
  query ExportTestSchools($input: ExportArgs!) {
    institutions: allTestSchools(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...exportInstitution
        }
      }
    }
  }
  ${EXPORT_INSTITUTION}
`;
